import axios from 'axios';

import { ServiceUrl } from '@portal/lib';

export const restApi = axios.create({
  baseURL: ServiceUrl,
  headers: {
    'Client-Name': 'dealer-portal',
  },
});